import React from 'react';
import IroColorPicker from './IroColorPicker';

class BSColorPicker extends React.Component{
  constructor(props) {
    super(props)

    this.state = {
     value: this.props.value
    }

    this.onInputChange = this.onInputChange.bind(this);
    this.onPickerChange = this.onPickerChange.bind(this);
   }

   onPickerChange = async (e) =>{
     console.log(e.hexString);

     this.setState({
         value: e.hexString
     });

     this.props.onPickerChange(this.props.name, e.hexString);
   }

   onInputChange = async (e) =>{
     console.log(e.target.value);

     
     this.setState({
         value: e.target.value
     });

     this.props.onPickerChange(this.props.name, e.target.value);
   };


  render(){
    return(
       <div className="BSColor">
                     <input name={this.props.name} 
                       value={this.state.value} 
                       onChange={this.onInputChange } 
                       type="text"
                     />  
                     <br />

                     <IroColorPicker
                       width="150"
                       color={this.state.value}
                       onColorChange={ this.onPickerChange }
                     />
       </div>
      )
    }
}

export default BSColorPicker;